import { initialize } from 'launchdarkly-js-client-sdk'
import { registerLaunchDarkly } from '~/plugins/launchDarkly/LaunchDarklyPlugin.common'

export default defineNuxtPlugin(async () => {
  return await registerLaunchDarkly(initialize)
})
